import { create } from "zustand";

/**
 * Its own store so the heavy graph-walking hooks (`useCableDemands`,
 * `usePathMinWireSizes`) can hold their last result for the whole drag — a
 * node/terminal positions and wire waypoints change neither demand nor wire size.
 */
interface CanvasDragState {
  isDragging: boolean;
  /** Every node in the gesture, not just the grabbed one: React Flow drags the
   *  whole selection when the grabbed node is part of it. */
  draggedNodeIds: ReadonlySet<string>;
  setIsDragging(value: boolean, nodeIds?: readonly string[]): void;
}

/** Shared so the idle identity is stable — edges would otherwise re-render on
 *  every unrelated drag-flag write. */
const NO_DRAGGED_NODES: ReadonlySet<string> = new Set<string>();

export const useCanvasDrag = create<CanvasDragState>((set) => ({
  isDragging: false,
  draggedNodeIds: NO_DRAGGED_NODES,
  setIsDragging: (value, nodeIds) =>
    set({
      isDragging: value,
      draggedNodeIds:
        value && nodeIds && nodeIds.length > 0
          ? new Set(nodeIds)
          : NO_DRAGGED_NODES,
    }),
}));
